import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { ConfirmationDialog } from '../../legacy-design-system/modal'
import { Textarea } from '../../legacy-design-system/form-text'

interface Props {
  readonly isOpen: boolean
  readonly status?: string
  readonly onDeny: (comment: string) => Promise<any>
  readonly onCancel: () => void
}

interface State {
  readonly comment: string
}

export class ConfirmDenyChangeStatusDialog extends React.Component<
  Props,
  State
> {
  public state: State = {
    comment: ''
  }

  public render() {
    const { onCancel, onDeny, status, isOpen } = this.props
    const { comment } = this.state

    return (
      <ConfirmationDialog
        size="medium"
        isOpen={isOpen}
        onCancel={onCancel}
        onConfirm={() => onDeny(comment)}
        renderConfirmMessage={() => <FormattedMessage id="action_deny" />}
        renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
        renderTitle={() => <FormattedMessage id="title_pleaseConfirmAction" />}
        renderBody={() => (
          <React.Fragment>
            <div>
              <FormattedMessage
                id={
                  status
                    ? 'title_denyVulnerabilityStatusChange'
                    : 'title_denyVulnerabilitiesStatusChange'
                }
                values={
                  status
                    ? {
                        status: <strong>{status}</strong>
                      }
                    : {}
                }
              >
                {(text) => {
                  return <p>{text}</p>
                }}
              </FormattedMessage>
              <FormattedMessage id="placeholder_leaveACommentForYourUser">
                {(message) => (
                  <div
                    className={css`
                      width: 100%;
                      height: 125px;
                      margin: 10px 0;
                    `}
                  >
                    <Textarea
                      expand
                      value={comment}
                      label=""
                      placeholder={message as any}
                      onChange={this.updateComment}
                    />
                  </div>
                )}
              </FormattedMessage>
            </div>
          </React.Fragment>
        )}
        confirmButtonProps={{
          disabled: !this.isValid()
        }}
      />
    )
  }

  private isValid = () => {
    return !!this.state.comment.trim()
  }

  private updateComment = (comment: string) => {
    this.setState({
      comment
    })
  }
}
